import { memo } from 'react';

import WarningDuotoneIconSVG from '@/assets/warning-duotone-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IWarningDuotoneIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={WarningDuotoneIconSVG} {...props} />
);

export const WarningDuotoneIcon = memo(IWarningDuotoneIcon) as typeof IWarningDuotoneIcon;
